import { Box } from '@zoopla-eng/zds-components/box';
import { Stack } from '@zoopla-eng/zds-components/stack';
import { NewHomesBody } from '../NewHomesBody';
import { NewHomesPageSubtitleShort } from '../NewHomesPageSubtitleShort';
import { NewHomesSectionSubtitle } from '../NewHomesSectionSubtitle';
import EmailIcon from './assets/email.svg';
import LocationIcon from './assets/location.svg';
import PricesIcon from './assets/prices.svg';
import { StyledImage } from './NewHomesContent.styles';

export const NewHomesContent = () => {
    return (
        <>
            <Box pb="$S500">
                <NewHomesPageSubtitleShort>
                    Find the latest new-build homes from the UK's leading house
                    builders
                </NewHomesPageSubtitleShort>
            </Box>
            <Stack
                flexDirection="row"
                columnGap="$S500"
                rowGap="$S500"
                items={{
                    flexBasis: '100%'
                }}
                {...{
                    '@M100': {
                        flexWrap: 'nowrap'
                    }
                }}
            >
                <Box>
                    <Box pb="$S100">
                        <StyledImage
                            src={LocationIcon}
                            alt="Email icon"
                            loading="lazy"
                        />
                    </Box>
                    <NewHomesSectionSubtitle>
                        Search for exactly what you want
                    </NewHomesSectionSubtitle>
                    <NewHomesBody>
                        Using advanced filters and drawing your search area.
                    </NewHomesBody>
                </Box>
                <Box>
                    <Box pb="$S100">
                        <StyledImage
                            src={EmailIcon}
                            alt="Location icon"
                            loading="lazy"
                        />
                    </Box>
                    <NewHomesSectionSubtitle>
                        Be first through the door
                    </NewHomesSectionSubtitle>
                    <NewHomesBody>
                        Thanks to instant property alerts.
                    </NewHomesBody>
                </Box>
                <Box>
                    <Box pb="$S100">
                        <StyledImage
                            src={PricesIcon}
                            alt="Prices icon"
                            loading="lazy"
                        />
                    </Box>
                    <NewHomesSectionSubtitle>
                        Compare the nitty gritty details
                    </NewHomesSectionSubtitle>
                    <NewHomesBody>
                        From price to square footage and features like parking
                        or outdoor space.
                    </NewHomesBody>
                </Box>
            </Stack>
        </>
    );
};
